import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=19a693c2&scoped=true&"
import script from "./Sites.vue?vue&type=script&lang=js&"
export * from "./Sites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a693c2",
  null
  
)

export default component.exports